import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  .title {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    @media (max-width: 560px) {
      flex-wrap: wrap;
    }

    h1 {
      font-weight: 600;
    }
  }
`;

export const AllManageStateContainer = styled.div`
  width: 100%;
  border-radius: 1rem;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const Cart = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: start;
  background-color: var(--white);
  padding: 2rem;
  gap: 2rem;
  @media (max-width: 870px) {
    flex-wrap: wrap;
    gap: 2rem;
  }

  .banner-img-title {
    display: flex;
    gap: 2rem;
    width: 90%;
    align-items: start;
  }

  .document-preview-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 300px;
    flex-shrink: 0;

    .pdf-preview-wrapper {
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }

    .document-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 1rem;
      padding: 1.5rem;
      border: 1px solid var(--border-color, #e0e0e0);
      border-radius: 0.8rem;
      background-color: var(--white);
      transition: transform 0.2s, box-shadow 0.2s;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 0.4rem 1.2rem rgba(0, 0, 0, 0.15);
      }

      .document-icon-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 80px;
        height: 80px;
        background-color: var(--light-gray, #f5f5f5);
        border-radius: 0.5rem;

        .document-icon {
          font-size: 4rem;
          color: var(--primary, #dc2626);
        }
      }

      .preview-button {
        padding: 0.8rem 2rem;
        background-color: var(--secondary);
        color: var(--white);
        border: none;
        border-radius: 0.5rem;
        font-size: 1.4rem;
        font-weight: 500;
        cursor: pointer;
        transition: background-color 0.2s, transform 0.2s;

        &:hover {
          transform: scale(1.05);
        }

        &:active {
          transform: scale(0.98);
        }
      }
    }

    .no-preview {
      width: 100%;
      height: 200px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: var(--light-gray);
      border: none;
      border-radius: 0.8rem;

      span {
        font-size: 1.6rem;
        color: var(--text-secondary);
      }
    }
  }

  .banner-title {
    flex: 1;
    display: flex;
    justify-content: center;
    flex-direction: column;
    gap: 2rem;
    min-width: 0;

    span {
      font-size: 2rem;
      font-weight: 400;
      color: var(--text);
    }

    h1 {
      font-size: 1.8rem;
      font-weight: 600;
      color: var(--text);
      margin: 0;
      word-break: break-word;
    }

    .document-links {
      display: flex;
      flex-direction: column;
      gap: 1rem;

      .document-link {
        color: var(--primary);
        text-decoration: none;
        font-size: 1.6rem;
        word-break: break-all;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }

  p {
    color: #1c1c27;
  }
`;

